import m from "../../geodata/es2015/continentsRussiaAsiaUltra";
window.am4geodata_continentsRussiaAsiaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaAsiaUltra.js
// module id = null
// module chunks = 